export default __webpack_public_path__ + "static/media/twitter-logo.9da9cb1e.svg";